// admin-panel/src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './hooks/useAuth';
import AdminLayout from './components/layout/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectForm from './pages/ProjectForm';
import Inquiries from './pages/Inquiries';
import InquiryDetail from './pages/InquiryDetail';
import Quotes from './pages/Quotes';
import QuoteForm from './pages/QuoteForm';
import Services from './pages/Services';
import Testimonials from './pages/Testimonials';
import Media from './pages/Media';
import CMS from './pages/CMS';
import Settings from './pages/Settings';
import Categories from './pages/Categories';
import Blog from './pages/Blog';
import BlogForm from './pages/BlogForm';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30000, retry: 1 } }
});

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#0F0F0F] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
  </div>;
  return user ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="projects" element={<Projects />} />
              <Route path="projects/new" element={<ProjectForm />} />
              <Route path="projects/:id/edit" element={<ProjectForm />} />
              <Route path="categories" element={<Categories />} />
              <Route path="inquiries" element={<Inquiries />} />
              <Route path="inquiries/:id" element={<InquiryDetail />} />
              <Route path="quotes" element={<Quotes />} />
              <Route path="quotes/new" element={<QuoteForm />} />
              <Route path="quotes/:id/edit" element={<QuoteForm />} />
              <Route path="services" element={<Services />} />
              <Route path="testimonials" element={<Testimonials />} />
              <Route path="media" element={<Media />} />
              <Route path="cms" element={<CMS />} />
              <Route path="settings" element={<Settings />} />
              <Route path="blog" element={<Blog />} />
              <Route path="blog/new" element={<BlogForm />} />
              <Route path="blog/:id/edit" element={<BlogForm />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" toastOptions={{
          style: { background: '#1A1A1A', color: '#fff', border: '1px solid #2A2A2A' },
          success: { iconTheme: { primary: '#D4AF37', secondary: '#0F0F0F' } },
        }} />
      </AuthProvider>
    </QueryClientProvider>
  );
}
